import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEditPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 11c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C9.602 8 10.068 8 11 8h10c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C24 9.602 24 10.068 24 11M12 24h8M14.25 8v16m3.5-16v16"
    />
  </svg>
);
export default SvgEditPdf;
